import { useContext, useEffect, useState } from 'react';
import { UserContext } from '../repository/context/userContext';

/**
 * Custom hook to manage country selection based on marketAccess
 * @param initialCountry - Initial country code (default: null)
 * @returns [countrySelected, setCountrySelected] - Country state and setter
 */
export function useCountrySelection(
  initialCountry: string | null = null,
): [string | null, (country: string | null) => void] {
  const userContext = useContext(UserContext);
  const [countrySelected, setCountrySelected] = useState<string | null>(initialCountry);

  // Set countrySelected based on marketAccess
  useEffect(() => {
    const marketAccess = userContext.user?.marketAccess || null;

    if (marketAccess === null) {
      // If null, default to USA
      setCountrySelected('USA');
    } else {
      // Parse marketAccess (e.g., "USA,CAN" or "CAN")
      const allowedCodes = marketAccess.split(',').map((code: string) => code.trim());

      // If only one country, set it as selected
      if (allowedCodes.length === 1) {
        setCountrySelected(allowedCodes[0]);
      }
      // If multiple countries, keep current selection or default to first one
      else if (allowedCodes.length > 1) {
        setCountrySelected('USA');
      }
    }
  }, [userContext.user?.marketAccess]);

  return [countrySelected, setCountrySelected];
}
